module.exports = __webpack_public_path__ + "static/media/raduno2005.04cc7f92.jpg";